import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import ParkingCategoryIcon from './ParkingCategoryIcon';
import ParkingCategoryTitle from './ParkingCategoryTitle';

const ParkingCategoryDesc = ({ parkingCategory }) => {
  if (parkingCategory) {
    return (
      <div className="d-flex align-items-center">
        <div className="mr-2">
          <ParkingCategoryIcon parkingCategory={parkingCategory} />
        </div>
        <TruncatedTooltipText>
          <ParkingCategoryTitle parkingCategory={parkingCategory} />
        </TruncatedTooltipText>
      </div>
    );
  }
  return null;
};

ParkingCategoryDesc.propTypes = {
  parkingCategoryId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  parkingCategory: cpmParkingCategoryDataShape,
};

ParkingCategoryDesc.defaultProps = {
  parkingCategoryId: null,
  parkingCategory: null, // May be null if user has not permission to load parking categories
};

const mapStateToProps = (state, ownProps) => ({
  parkingCategory: _find(state.cpmCarparkParkingCategory.list.elements, ['id', ownProps.parkingCategoryId]),
});

module.exports = connect(
  mapStateToProps,
)(ParkingCategoryDesc);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategoryDesc.js